import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, HostListener, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { PaginationService } from '../../services/pagination.service';
import { ListingService } from '@app/core/services/listing.service';
import { ImageUtil } from '@app/shared/utils/image.util.service';
import { ListingCategoryService } from '@app/core/services/listing-category.service';
import { LisitingCategory } from '@app/models/listing-category.model';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, map, switchMap, take, tap, takeUntil } from 'rxjs/operators';
import { AlgoliaService } from '@app/core/services/algolia.service';
import { AlgoliaQueryOption } from '@app/models/algolia-query-option.model';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MapResultComponent } from '../../components/map-result/map-result.component';

@Component({
  selector: 'app-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss'],
  providers: [PaginationService]
})
export class ListingComponent implements OnInit, OnDestroy {
  public lists: any;
  public userID: any;

  loading = false;
  categories: { source: LisitingCategory, checked: boolean }[] = [];

  minRentalPriceRange = null;
  maxRentalPriceRange = null;

  sortBy = '0';
  unsubscribe$ = new Subject();

  get ifNotRoot(): boolean {
    return this.router.url.includes('/listing/');
  }

  rentals$ = new Observable<any[]>();
  pageEvent$ = new BehaviorSubject<number>(1);
  currentPage = 0;
  isQueryLoading = false;
  results = [];
  hasNoMoreResults = false;

  searchedListing: any[];

  modalRef: any;

  @HostListener("window:scroll", ["$event"])
  onWindowScroll() {
    //In chrome and some browser scroll is given to body tag
    let pos = (document.documentElement.scrollTop || document.body.scrollTop) + document.documentElement.offsetHeight;
    let max = document.documentElement.scrollHeight - 10;
    if (pos >= max && this.results && this.results.length) {
      this.scrollHandler('bottom');
    }
  }

  constructor(
    private router: Router,
    public listingService: ListingService,
    public paginationService: PaginationService,
    private imageUtil: ImageUtil,
    public categoryService: ListingCategoryService,
    private algoliaService: AlgoliaService,
    private ngbModal: NgbModal
  ) {

    this.loading = true;
  }

  ngOnInit() {
    this.categoryService.getParentCategories()
      .subscribe((res) => {
        this.categories = res.map(d => ({ source: d, checked: false }));
      }, (err) => {
        console.error(err);
      });
    localStorage.getItem('user')
      ? (this.userID = JSON.parse(localStorage.getItem('user')).uid)
      : (this.userID = null);
    this.getList();
  }

  ngOnDestroy() {
    this.loading = false;
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  getList() {
    this.rentals$ = this.pageEvent$.asObservable()
      .pipe(
        debounceTime(100),
        tap(() => this.isQueryLoading = true),
        switchMap(page => {
          let sorting = undefined;
          if (this.sortBy === '1') {
            sorting = 'asc';
          } else if (this.sortBy === '2') {
            sorting = 'desc';
          }
          const algoliaQueryOptions: AlgoliaQueryOption = {
            page: this.currentPage,
            hitsPerPage: 30,
            rentalPriceSort: sorting,
            priceRange: {
              max: this.minRentalPriceRange,
              min: this.maxRentalPriceRange
            },
            // filters: this.generateCategoryFilter()
            filters: ''
          };
          return this.algoliaService.search('', algoliaQueryOptions);
        }),
        map(res => {
          if (res.hits.length <= 0) {
            this.hasNoMoreResults = true;
          } else {
            this.results.push(...res.hits);
          }
          this.searchedListing = [...this.results];
          return this.results;
        }),
        tap(() => {
          this.loading = false;
          this.isQueryLoading = false;
        }),
        catchError(() => {
          this.loading = false;
          this.isQueryLoading = false;
          return of([]);
        })
      );
  }

  invokeEvent() {
    const randNum = Math.random() * 2000;
    this.pageEvent$.next(randNum);
  }

  scrollHandler(event) {
    if (event === 'bottom' && !this.hasNoMoreResults && !this.isQueryLoading) {
      this.isQueryLoading = true;
      this.currentPage += 1;
      this.invokeEvent();
    }
  }


  generateCategoryFilter() {
    const selectedCats = this.categories.filter(d => d.checked);
    let filterQuery = '';
    for (const x of selectedCats) {
      filterQuery += `category.parentId: ${x.source.id} OR `;
    }
    const lastIndex = filterQuery.lastIndexOf('OR');
    filterQuery = filterQuery.substring(0, lastIndex);

    return filterQuery;
  }

  categoryChange(source) {
    this.reset();
    this.invokeEvent();
  }

  goToDetails(listingID) {
    this.loading = true;
    this.router.navigate(['listing/details', listingID]);
    // userID === this.userID
    //   ? this.router.navigate(['profile/my-listing', listingID])
    //   : this.router.navigate(['listing/details', listingID]);
  }

  getBackgroundImageStyle(imageUrl: string) {
    return this.imageUtil.getBackgroundImageStyle(imageUrl);
  }

  emitSortBy() {
    this.reset();
    this.invokeEvent();
  }

  emitPriceRange(source) {
    this.minRentalPriceRange = source.min;
    this.maxRentalPriceRange = source.max;
    this.reset();

    this.invokeEvent();
  }

  reset() {
    this.currentPage = 0;
    this.hasNoMoreResults = false;
    this.results = [];
  }

  openMapModal() {
    this.modalRef = this.ngbModal.open(
      MapResultComponent,
      {
        windowClass: "map-modal",
        centered: true
      }
    );

    this.modalRef.componentInstance['listings'] = this.searchedListing;
  }

}
